import { useContextMenu } from '../../context-menu';

export type ContextMenuInformationParams = {
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ContextMenuInformation = (params: ContextMenuInformationParams): React.ReactElement => {
	const [contextMenuHook] = useContextMenu();

	return (
		<div style={{
			zIndex: 10,
			maxWidth: '400px',
			backgroundColor: 'rgba(255, 255, 255, 0.55)',
			border: '1px solid #ccc',
			borderRadius: '8px',
			padding: '15px',
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
		}}>
			<h3 style={{ margin: '0 0 15px 0', fontSize: '16px' }}>Context Info</h3>
			<div style={{ fontSize: '12px' }}>
			<div key={'context-menu-key'}><strong>menu key:</strong> {contextMenuHook.context.menuKey}</div>
			<div key={'context-menu-ceter'}><strong>menu center:</strong> {contextMenuHook.context.center.x} : {contextMenuHook.context.center.y}</div>
			<div key={'context-menu-position'}><strong>menu position:</strong> {contextMenuHook.position.x} : {contextMenuHook.position.y}</div>
			<div key={'context-menu-relative'}><strong>menu relative:</strong> {contextMenuHook.relative.x} : {contextMenuHook.relative.y}</div>
			</div>
		</div>
	);
};
